export default function PrepareCarMatrixFactory(l10nService) {
    'ngInject';

            return prepareMatrix;

            function prepareMatrix(matrix) {

                /**
                 * List of car classes
                 */
                const carClasses = [
                    l10nService.localize('Mini'),
                    l10nService.localize('Mini Elite'),
                    l10nService.localize('Economy'),
                    l10nService.localize('Economy Elite'),
                    l10nService.localize('Compact'),
                    l10nService.localize('Compact Elite'),
                    l10nService.localize('Intermediate'),
                    l10nService.localize('Intermediate Elite'),
                    l10nService.localize('Standard'),
                    l10nService.localize('Standard Elite'),
                    l10nService.localize('Fullsize'),
                    l10nService.localize('Fullsize Elite'),
                    l10nService.localize('Premium'),
                    l10nService.localize('Premium Elite'),
                    l10nService.localize('Luxury'),
                    l10nService.localize('Luxury Elite'),
                    l10nService.localize('Oversize'),
                    l10nService.localize('Special'),
                ];

                const usedCarClasses = _.intersection(carClasses, _.uniq(_.map(matrix.CarPrices, 'CarClass')));
                const carPrices = [];

                _.forEach(usedCarClasses, function(carClass) {
                    const prices = [];
                    const companyNames = [];

                    _.forEach(matrix.CarCompanies, function(company) {
                        const car = _.find(matrix.CarPrices, {AddressId: company.Key, CarClass: carClass});
                        const carPrice = car
                            ? {price: car.Price, isNegotiated: car.IsNegotiated}
                            : {price: 0};

                        prices.push(carPrice);
                        companyNames.push(company.Name);
                    });


                    carPrices.push({
                        className: carClass,
                        providers: companyNames,
                        prices,
                    });
                });

                return {
                    companies: matrix.CarCompanies,
                    mapCompanies: matrix.Companies,
                    cars: carPrices,
                    carClasses: usedCarClasses,
                    carPrices: matrix.CarPrices,
                };
            }

}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/prepareCarMatrixFactory.js